import { createContext } from 'react';

// One collector per build-time render; never shared across requests.
export const SeoContext = createContext(null);
